import * as Joi from "joi";
import { Column, Entity } from 'typeorm';
import { GenPartial } from 'typeormgen';
import EpisodicCharacterNoteBase from '../episodic-character-note-base.entity';

@Entity('mu_episodic_characters')
export default class MuEpisodicCharacter extends EpisodicCharacterNoteBase {
	static readonly tableName = 'mu_episodic_characters';

	@Column('varchar')
	m_note: string;

	static rules() {
		return {
			...EpisodicCharacterNoteBase.rules(),
			m_note: Joi.string().allow(null, ''),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
			m_note: this.m_note,
		};
	}

	assign(props?: GenPartial<MuEpisodicCharacter>) {
		super.assign(props);
	}

	constructor(props?: GenPartial<MuEpisodicCharacter>) {
		super(props);
	}

	get note() {
		return this.m_note;
	}

	set note(note: string) {
		this.m_note = note;
	}
}
